<template>
  <div v-if="question.subQuestions && question.subQuestions.length > 0">
    <PreviewQuestionInfo
      :mainQuestionId="question.id"
      :mainQuestionIndex="questionIndex"
      :questions="question.subQuestions"
      :section="section"
      :sectionIndex="sectionIndex"
      :isSubQuestion="isSubQuestion"
      :isBundle="isBundle"
    />
  </div>
  <div v-else>
    <p class="no-sub-question">ไม่มีคำถาม</p>   
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    section: Object,
    question: Object,
    questionIndex: Number,
    sectionIndex: Number,
    isDeleteQuestion: Boolean,
    isBundle: Boolean,
  },
  data() {
    return {
      token: localStorage.getItem("token"),
      sectionId: "",
      questionId: "",
      questionChoicesNew: [],
      questionType: "MULTIPLE_CHOICE",
      isSubQuestion: true,
    };
  },
  components: {
    PreviewQuestionInfo: () => import("./PreviewQuestionInfo.vue"),
  },
  computed: {
    ...mapGetters("ExamBuilder", ["exam", "tempQuestion", "tempChoice"]),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.no-sub-question {
    color: orange;
    width: 100%;
    padding: 10px;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 5px;
}

.button-create-new {
  display: flex;
  justify-content: flex-end;
}
</style>